/**
 * 2つの時間を比較して、差分の範囲を配列で返す
 * @param {string} fromTime 比較対象の日時 ex.0:00
 * @param {string} toTime 比較対象の日時 ex.23:45
 * @returns ex.['0:00',  '0:15',  '0:30', '23:45']
 */
export const arrayOfTimeInterval = (slotMinTime: string, slotMaxTime: string) => {
  const [startHour, startMin] = slotMinTime.split(':');
  const [endHour, endMin] = slotMaxTime.split(':');
  const times = [] as any;

  for (let hour = Number(startHour); hour <= Number(endHour); hour++) {
    times.push([`${hour}:00`, `${hour}:15`, `${hour}:30`, `${hour}:45`]);
  }
  const timeRanges = times.flat();

  const startIndex = timeRanges.findIndex((time: string) => {
    return time === `${startHour}:${startMin}`;
  });
  timeRanges.splice(0, startIndex);

  const endIndex = timeRanges.findIndex((time: string) => {
    return time === `${endHour}:${endMin}`;
  });
  const deleteCount = 3;
  timeRanges.splice(endIndex + 1, deleteCount);

  return timeRanges;
};

export default arrayOfTimeInterval;
